import React from 'react';
import InteractivePane from '../../InteractivePane';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const ConversationalInterfaceLayout = _ref => {
  let {
    environment,
    exercise,
    exerciseId,
    onCheckExercise,
    onContinue,
    onExerciseStatusUpdate,
    resources,
    user
  } = _ref;
  return ___EmotionJSX(InteractivePane, {
    enableToggleInstructionsButton: false,
    environment: environment,
    exercise: exercise,
    exerciseId: exerciseId,
    onCheckExercise: onCheckExercise,
    onContinue: onContinue,
    onExerciseStatusUpdate: onExerciseStatusUpdate,
    resources: resources,
    user: user
  });
};